import type { BusinessModel, BusinessPersistenceModel } from '../../data-layer/business/types';
import type { BusinessPersistenceUI } from '../../ui/business/types';

export const toBusinessPersistenceUI = (
    model: BusinessModel | BusinessPersistenceModel,
): BusinessPersistenceUI => ({
    id: model.id,
    publicId: model.publicId,
    displayName: model.displayName,
    description: model.description,
    avatarUrl: model.avatarUrl,
    coverUrl: model.coverUrl,
    links: model.links,
    createdAt: model.createdAt,
    hideInFeed: Boolean(model.hideInFeed),
    offerAgreement: model.offerAgreement,
    instagram: model.instagram,
    categories: model.categories,
    useProductsAutoImport: model.useProductsAutoImport,
    useProductsDisableAutoParser: model.useProductsDisableAutoParser,
    allowedToBoosts: model.allowedToBoosts,
});
